import React from "react";
import {useTranslate} from "@tolgee/react";

export const RedirectToWhatsAppManager = ({ locationUUID }) => {

    const {t} = useTranslate();

    const whatsAppTemplateManagerLink = `${window.location.origin}/platform/whatsapp/redirect-to-meta-whatsapp-manager/${locationUUID}/`;

    return (
        <a
            href={whatsAppTemplateManagerLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-secondary"
        >
            {t("whatsappTemplate.SendTemplate.header.openWhatsAppTemplateSettings")}
        </a>
    );
};